import clsx from 'clsx';
import { useState } from 'react';
import { useUser } from '@/stores/authStore';
import { PoolFilters } from '@/types/pool';
import { isBorrower } from '@/utils/user';
import { DraftPoolList } from './DraftPoolList';
import { PoolListEmptyMessages, PoolListTab, ReadyPoolList } from './ReadyPoolList';

export type { PoolListEmptyMessages, PoolListTab };

type PoolListProps = {
  tabs: PoolListTab[];
  defaultTab: string;
  getTabFilters: (tabId: string) => PoolFilters;
  emptyMessages: PoolListEmptyMessages;
};

export default function PoolList({ tabs, defaultTab, getTabFilters, emptyMessages }: PoolListProps) {
  const [showDraftPools, setShowDraftPools] = useState(false);
  const user = useUser();
  const isBorrowerUser = isBorrower(user);

  return (
    <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-20 mt-12 lg:mt-20">
      <div className={clsx('w-full', showDraftPools ? 'hidden' : 'animate-slide-right')}>
        <ReadyPoolList
          tabs={tabs}
          defaultTab={defaultTab}
          getTabFilters={getTabFilters}
          emptyMessages={emptyMessages}
          onShowDraftPools={() => setShowDraftPools(true)}
        />
      </div>
      {isBorrowerUser && (
        <div className={clsx('w-full', showDraftPools ? 'animate-slide-left' : 'hidden')}>
          <DraftPoolList onBackToReady={() => setShowDraftPools(false)} />
        </div>
      )}
    </div>
  );
}
